import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GrooveCandidateService } from '../groove-candidate.service';

@Component({
  selector: 'app-groove-candidate-switcher',
  templateUrl: './groove-candidate-switcher.component.html',
  styleUrl: './groove-candidate-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrooveCandidateSwitcherComponent {
  private readonly service = inject(GrooveCandidateService);
  protected readonly candidate = this.service.candidate;
  protected set(value: string): void {
    this.service.set(value as 'none' | 'warm' | 'neutral' | 'cool');
  }
}
